import type { FC } from 'react'

import { css } from '@emotion/react'

import { useGameSettingsState } from '@/state/game'

export const StatusBar: FC = () => {
  const { gameStarted, turn } = useGameSettingsState((state) => ({
    gameStarted: state.gameStarted,
    turn: state.turn,
  }))
  return (
    <div
      css={css`
        position: absolute;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
        color: #D72A29;
        font-size: 16px;
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        background: rgba(30, 40, 54, 0.8);
        padding: 10px 20px;
        border-radius: 8px;
        border: 1px solid #D72A29;
        backdrop-filter: blur(5px);
        span {
          color: #ffffff;
          font-weight: 600;
        }
      `}
    >
      {gameStarted && (
        <p>
          Turn{` `}
          <span>{turn === 'white' ? 'You' : 'Computer'}</span>
        </p>
      )}
    </div>
  )
}
